import $ from 'jquery';

const accordion = () => {
  $('.accordion').on('click', (e) => {
    const $parent = $(e.currentTarget).parent();
    const $p = $parent.find('p');

    if ($parent.hasClass('is-current')) {
      $p.animate({ height: 0 }, 200);
      $parent.removeClass('is-current');

    } else {

      const currentHeight = $p.height();
      const autoHeight = $p.css('height', 'auto').height();

      $p.height(currentHeight);
      $p.stop().animate({ height: autoHeight }, 200);
      $parent.addClass('is-current');
    }
  });
};

export default accordion;
